import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight, Clock, ChevronRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OtherDestinations() {
  const [destinations, setDestinations] = useState([]);

  useEffect(() => {
    axios.get(`${API}/destinations`)
      .then(res => setDestinations(res.data.filter(d => !d.is_featured)))
      .catch(console.error);
  }, []);

  return (
    <div>
      <div className="bg-[#EFEBE5] px-6 md:px-12 lg:px-24 py-3">
        <div className="max-w-7xl mx-auto flex items-center gap-2 text-sm font-body text-[#6B6B6B]">
          <Link to="/" className="hover:text-[#2D5016]">Accueil</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-[#2D5016] font-medium">Nos autres destinations</span>
        </div>
      </div>

      <section className="py-20 md:py-32 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-[#C8A951] font-body text-sm tracking-[0.3em] uppercase mb-3">A decouvrir aussi</p>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#2C2C2C]">Nos autres destinations</h1>
            <p className="font-body text-[#6B6B6B] mt-4 max-w-2xl mx-auto">
              D'autres voyages immersifs a la rencontre des peuples, entre temples seculaires, traditions vivantes et paysages grandioses.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {destinations.map((dest, i) => (
              <Link
                key={dest.slug}
                to={`/destinations/${dest.slug}`}
                className="destination-card group relative overflow-hidden rounded-xl aspect-[4/3]"
                data-testid={`other-dest-card-${dest.slug}`}
              >
                <img src={dest.card_image} alt={dest.name} className="card-image w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2C2C2C]/80 via-[#2C2C2C]/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <div className="flex items-center gap-2 mb-2">
                    <Clock className="w-4 h-4 text-[#C8A951]" />
                    <span className="text-[#C8A951] font-body text-xs tracking-widest uppercase">{dest.duration} jours</span>
                  </div>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-1">{dest.name}</h2>
                  <p className="text-white/80 font-body text-sm italic mb-3">{dest.tagline}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-[#C8A951] font-body font-bold text-lg">A partir de {dest.price} EUR</span>
                    <span className="text-white font-body text-sm flex items-center gap-1 group-hover:gap-3 transition-all">
                      En savoir plus <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
